import React, { Fragment } from 'react';

const BarPactometro = ({ parties }) => {
  const names = parties.map(p => p.name).join(' - ');

  return (
    <Fragment>
      <div className="parties-title">{names}</div>
      <div
        className="bar-content"
      >
        {parties.map(p => {
          return (
            <div
              key={p.name}
              className="bar-segment"
              style={{
                width: `${p.percent}%`,
                backgroundColor: p.color,
                height: "20px",
                float: "left"
              }}
              title={p.name}
            ></div>
          );
        })}
        <div className="bar-mayoria">176</div>
      </div>
    </Fragment>
  );
};

export default BarPactometro;
